export default __webpack_public_path__ + "static/media/customers.39030db6.webp";